import {ChartsDataContainer} from '../NetatmoCommon';

export default class HomeDataHandler extends ChartsDataContainer {}
